<script lang="ts" setup>
interface NavigationItem {
  label: string
  Title?: string
  Link?: string
  url?: string
  children?: NavigationItem[]
  Column1?: unknown[]
  Column2?: unknown[]
  Column3?: unknown[]
  Banner1?: unknown
  Banner2?: unknown
  Banners?: unknown[]
}

defineProps<{
  item: NavigationItem
}>()
</script>

<template>
  <div class="subnavigation__content--banners">
    <NavigationBannerSmall
      v-for="banner in item.Banners"
      :key="banner"
      :banner="banner"
      :lazy="true"
    />
  </div>
</template>

<style>
@import url("~layers/app/components/Navigation/Level2Banners.css");
</style>
